import React, { useEffect, useState, useMemo } from "react";
import TableContainer from "../../components/Common/TableContainer";
import { Card, CardBody, Col, Row, Spinner } from "reactstrap";
import { getAllUsers, getAllCountries } from "api";
import { handleError } from "utils/errorHandler";

const AppUsers = () => {
  const [users, setUsers] = useState([]);
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        const [usersData, countriesData] = await Promise.all([
          getAllUsers(),
          getAllCountries().catch(() => []),
        ]);
        const appUsersList = Array.isArray(usersData) ? usersData.filter(user => Number(user.userRole) === 6) : [];
        setUsers(appUsersList);
        setCountries(Array.isArray(countriesData) ? countriesData : []);
      } catch (error) {
        handleError(error);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  const columns = useMemo(
    () => [
      {
        header: "Name",
        accessorKey: "name",
      },
      {
        header: "Email",
        accessorKey: "email",
      },
      {
        header: "Phone",
        accessorKey: "phoneNo",
      },
      {
        header: "Country",
        accessorFn: (row) => {
          const countryObj = countries.find(
            (c) => String(c.countryId) === String(row.location)
          );
          return countryObj ? countryObj.countryName : "-";
        },
        id: "country",
        cell: (cell) => cell.getValue(),
      },
      {
        header: 'Created Date',
        accessorKey: 'createdAt',
        filterFn: (row, columnId, filterValue) => {
          const val = row.getValue(columnId);
          if (!val) return false;
          const display = new Date(val).toLocaleDateString();
          return display.toLowerCase().includes(String(filterValue).toLowerCase());
        },
        cell: (cell) => {
          const date = cell.getValue();
          return date ? new Date(date).toLocaleDateString() : "-";
        }
      },
    ],
    [countries]
  );

  return (
    <Row>
      <Col lg="12">
        <Card>
          <CardBody>
            {loading ? (
              <div className="text-center py-5">
                <Spinner />
              </div>
            ) : (
              <TableContainer
                columns={columns}
                data={users}
                isGlobalFilter
                isPagination
                SearchPlaceholder="Search app users..."
                tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100"
                theadClass="table-light"
                pagination="pagination"
              />
            )}
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default AppUsers;
